import { replace } from 'react-router-redux';
import { getShopList, getReservationList, getReservation, checkReservationCount } from 'actions/reservation';
import { getMemberData } from 'actions/member';

export default store => ({
	path: 'reserve',
	indexRoute: {
		getComponent: (nextState, cb) =>
			require.ensure(
				[],
				require => {
					const component = require('./Home').default;
					cb(null, component);
				},
				'reserve',
			),
		onEnter: () => {
			store.dispatch(getReservationList());
			store.dispatch(getMemberData());
			const { auth: { token: { accessToken } } } = store.getState();
			if (accessToken === '') {
				store.dispatch(replace('/login'));
			}
		},
	},
	childRoutes: [
		{
			path: 'add',
			indexRoute: {
				getComponent: (nextState, cb) =>
					require.ensure(
						[],
						require => {
							const component = require('./Add').default;
							cb(null, component);
						},
						'add',
					),
				onEnter: () => {
					store.dispatch(checkReservationCount());
					store.dispatch(getShopList());
				},
			},
		},
		{
			path: ':id',
			indexRoute: {
				getComponent: (nextState, cb) =>
					require.ensure(
						[],
						require => {
							const component = require('./Info').default;
							cb(null, component);
						},
						'info',
					),
				onEnter: ({ params }) => {
					store.dispatch(getReservation(params.id));
				},
			},
		},
	],
});



// WEBPACK FOOTER //
// ./src/routes/Reserve/index.js